import owl from './img/owl.svg'
import diamond from './img/diamond.svg'
import diamondGrey from './img/diamond-grey.svg'
import diamondBlack from './img/diamond-black.svg'
const Plugin = {
  install (Vue, options = {}) {
    if (this.installed) {
      return
    }
    const imageUrl = {
      logo: owl,
      icon: diamond,
      iconGrey: diamondGrey,
      iconBlack: diamondBlack
    }
    this.installed = true

    Vue.component('premiumImage', {
      functional: true,
      props: {
        type: {
          type: String,
          required: true
        }
      },
      render: function (createElement, context) {
        return createElement(
          'img',
          {
            ...context.data,
            attrs: {
              ...context.data.attrs,
              src: imageUrl[context.props.type],
              alt: `premium ${context.props.type}`,
              loading: 'lazy'
            }
          }
        )
      }
    })
  }
}

// This exports the plugin object.
export default Plugin
